import React from "react";
import ChargeBackAndDisputeOverview from "./ChargeBackAndDisputeOverview";
import FraudManagmentOverview from "./FraudManagmentOverview";
import ProgramManagementServicesOverview from "./ProgramManagementServicesOverview";
import CardPrinterOverview from "./CardPrinterOverview";
import DigitalWalletsOverview from "./DigitalWalletsOverview";
import ECommerceOverview from "./E-CommerceOverview";
import MobileTextMessagesServiceOverview from "./MobileTextMessagesServiceOverview";
import AutomatedClearingHouseOverview from "./AutomatedClearingHouse";
import NightlyFilesOverview from "./NightlyFilesOverview";
import { DataNotFound } from "../../../../Components/SharedComponent/ReviewSummarySectionNotFound/DataNotFound";

const OptionalFeatures = ({ data }) => {
  if (!data) return <DataNotFound />;

  return (
    <React.Fragment>
      <FraudManagmentOverview data={data} />
      <div style={{ marginBottom: "16px" }}></div>
      <ChargeBackAndDisputeOverview data={data} />
      <div style={{ marginBottom: "16px" }}></div>
      <ProgramManagementServicesOverview data={data} />
      <div style={{ marginBottom: "16px" }}></div>
      <CardPrinterOverview data={data} />
      <div style={{ marginBottom: "16px" }}></div>
      <DigitalWalletsOverview data={data} />
      <div style={{ marginBottom: "16px" }}></div>
      <ECommerceOverview data={data} />
      <div style={{ marginBottom: "16px" }}></div>
      <MobileTextMessagesServiceOverview data={data} />
      <div style={{ marginBottom: "16px" }}></div>
      <AutomatedClearingHouseOverview data={data} />
      <div style={{ marginBottom: "16px" }}></div>
      <NightlyFilesOverview data={data} />
    </React.Fragment>
  );
};
export default OptionalFeatures;
